import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=174ce82c&scoped=true&"
import script from "./FooterBar.vue?vue&type=script&lang=ts&"
export * from "./FooterBar.vue?vue&type=script&lang=ts&"
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=174ce82c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174ce82c",
  null
  
)

export default component.exports